import React from "react";
import {
  IconButton,
  Input,
  InputGroup,
  InputLeftElement,
  InputRightElement,
  useColorModeValue,
} from "@chakra-ui/react";
import { SearchIcon, CloseIcon } from "@chakra-ui/icons";

export function SearchBar({ value, onChange, ...props }) {
  const { variant, background, placeholder, borderRadius, ...rest } = props;

  const searchIconColor = useColorModeValue("gray.700", "white");
  const inputBg = useColorModeValue("secondaryGray.300", "navy.900");
  const inputText = useColorModeValue("gray.700", "gray.100");

  const handleClear = () => {
    onChange({ target: { value: "" } }); // mimic input event
  };

  return (
    <InputGroup w={{ base: "100%", md: "200px" }} {...rest}>
      <InputLeftElement>
        <IconButton
          bg="inherit"
          borderRadius="inherit"
          _hover="none"
          _active={{ bg: "inherit", transform: "none", borderColor: "transparent" }}
          _focus={{ boxShadow: "none" }}
          icon={<SearchIcon color={searchIconColor} w="15px" h="15px" />}
          aria-label="Search"
        />
      </InputLeftElement>

      <Input
        variant="flushed"
        fontSize="sm"
        bg={background || inputBg}
        color={inputText}
        fontWeight="500"
        _placeholder={{ color: "gray.400", fontSize: "14px" }}
        borderRadius={borderRadius || "30px"}
        placeholder={placeholder || "Search..."}
        value={value}
        onChange={onChange}
      />

      {value && (
        <InputRightElement>
          <IconButton
            size="xs"
            icon={<CloseIcon w={2.5} h={2.5} />}
            aria-label="Clear"
            onClick={handleClear}
            bg="transparent"
            color="red.400"
            _hover={{ color: "red.500" }}
          />
        </InputRightElement>
      )}
    </InputGroup>
  );
}
